<template>
  <div>
    <div class="container">
      <div class="margin-b20">原材料详情</div>
      <el-form ref="form" :model="formData" label-width="180px">
        <el-row>
          <template v-for="(item, index) in labelList">
            <el-col :span="12">
              <el-form-item :label="item.label"
                >{{
                  dealList.includes(String(item.value))
                    ? showList(item.value, formData[item.value])
                    : formData[item.value]
                }}
              </el-form-item>
            </el-col>
          </template>
        </el-row>
      </el-form>
    </div>
    <div class="container">
      <el-tabs
        v-model="activeIndex"
        class="tabs-area"
        type="card"
        @tab-click="handleTab"
      >
        <el-tab-pane label="原材料采购订单" name="0"></el-tab-pane>
        <el-tab-pane label="库存订单" name="1"></el-tab-pane>
        <el-tab-pane label="成品现货" name="2"></el-tab-pane>
      </el-tabs>

      <div v-if="activeIndex === '2'">
        <el-form ref="formName" :model="availableData" label-width="200px">
          <el-form-item
            label="原材料供应商名称："
            prop="materialSupplierCompanyName"
          >
            {{ availableData.materialSupplierCompanyName }}
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input
              v-model="availableData.remark"
              type="textarea"
              :rows="4"
              placeholder="请输入备注"
              maxlength="300"
              disabled
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
        <!--品类、采购合同上传、附件整合-->
        <common-upload
          ref="commonRef"
          :supplier-company-id="availableData.materialSupplierCompanyId"
          :form-data="availableData"
          :is-detail="isDetail"
          :is-only-view="isOnlyView"
          :ai-audit-type="chengpinxianhuoAiAuditType"
        />
      </div>
      <div v-else>
        <tableList
          row-key="id"
          :loading="false"
          :index-show="true"
          :table-data="tableData"
          :table-label="tableLabel"
          max-height="400"
        >
          <template #aiCheckResultHeader>
            <div class="flex-all-center">
              AI审查建议结果
              <eui-tooltip :content="aiCheckResultTip" placement="top"> 
              <eui-icon icon="eicon-r-changjianwenti" font-size="14px" color="#666666" />
            </eui-tooltip>
            </div>
          </template>
            <template #toStockOrderOne="{ scope: { row } }">
            <span class="color-b" @click="toStockOrder(1, row)">{{
              row.orderNo
            }}</span>
          </template>
          <template #toStockOrderTwo="{ scope: { row } }">
            <span class="color-b" @click="toStockOrder(2, row)">{{
              row.seqNo
            }}</span>
          </template>
          <!--附件-->
          <template #attachmentUpload="{ scope: { row } }">
            <eui-btn
              type="text"
              @click="handleUpload(row.lbbm, row.orderSkuId, 'upload')"
            >
              <span v-if="row.aiCheckResult && row.aiCheckResult !== '不需要审查'" style="color: #f0250f">*</span>上传
            </eui-btn>
            <!--            v-if="orderSkuIdArr.includes(row.orderSkuId)"-->
            <eui-btn
              type="text"
              @click="handleUpload(row.lbbm, row.orderSkuId, 'view')"
              >查看
            </eui-btn>
          </template>
          <template #aiCheckResult="{ scope: { row } }">
            <div
                    v-if="activeIndex === '1'"
                    :class="{ 'color-red': row.aiCheckResult === '审查不通过' }"
                    @click="showCheckResult(row.requestId, row.aiCheckResult)"
            >
              {{ row.aiCheckResult }}
            </div>
            <div
            v-else
              :class="{ 'color-red': row.aiCheckResult === '审查不通过' }"
             
            >
              {{ row.aiCheckResult }}
            </div>

          </template>
        </tableList>
      </div>
    </div>
    <!--AI审查建议结果-->
    <AIDataReport
      v-if="dataReportVisible"
      :dataReportVisible.sync="dataReportVisible"
      :target-id="targetId"
      :type="aiAuditType"
    />
  </div>
</template>

<script>
import eSearch from '@/modules/projectA/components/common/e-search';
import {epecMallUrl} from '@/modules/projectA/api/config';
import tableList from '../../components/common/e-table-list.vue';
import AIDataReport from '../../components/common/AIDataReport';
import {detailContent} from './common/rawMaterialDetail';
import api from '../../api/order';
import commonUpload from './components/commonUpload';

export default {
  name: 'RawMaterialDetail',
  components: {
    eSearch,
    tableList,
    AIDataReport,
    commonUpload,
  },
  data() {
    return {
      dataReportVisible: false,
      targetId: '',
      isDetail: true,
      isOnlyView: false,
      labelList: detailContent.purchaseFormData,
      formData: {},
      availableData: {},
      activeIndex: '0',
      checked: false,
      tableData: [],
      tableLabel: detailContent.yclTableLabel,
      queryData: {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      stockAffirmId: '',
      dealList: ['isDoC', 'purchaseRequestType', 'stockType', 'dataType'],
      // 审查类型1:sku;2:库存单;3:采购意向单成品现货；4：石化商城成品现货
      aiAuditType: '',
      chengpinxianhuoAiAuditType: 3,
      aiCheckResultTip: 'AI审查建议结果仅作为业务处理的参考依据，不会中断或者阻止正常业务流程。',
    };
  },
  mounted() {
    const {type = 0, stockAffirmId, petroMallOrderId} = this.$route.query;
    this.stockAffirmId = stockAffirmId;

    if (type === '2') {
      this.labelList = detailContent.mallOrderFormData;
      this.queryDetail('pmOrderDetail', {id: petroMallOrderId});
      this.chengpinxianhuoAiAuditType = 4;
    } else {
      this.labelList = detailContent.purchaseFormData;
      this.queryDetail('ecPurchasePlanDetail', {stockAffirmId});
      this.chengpinxianhuoAiAuditType = 3;
    }

    this.getData();
  },
  methods: {
    showCheckResult(requestId, aiCheckResult) {
      if (aiCheckResult === '审查不通过') {
        // this.targetId = id;
        // this.aiAuditType = 2;
        // this.dataReportVisible = true;

        window.open(`${epecMallUrl}/intelligentReview?id=${requestId}`, '_blank');
      }
    },
    // 处理附件上传数据
    dealAttachmentFileData(tableData) {
      const isExistIndex = this.aiCheckFileList.findIndex(item => item.orderSkuId === this.orderSkuId);
      const attachListData = tableData.filter(item => item.attachList.length > 0);
      const attachListArr = attachListData.map(item => item.attachList);
      const params = {
        orderSkuId: this.orderSkuId,
        attachList: attachListArr
      };
      // 用于查看数据
      const viewParams = {
        orderSkuId: this.orderSkuId,
        tableData
      }

      if (isExistIndex === -1) {// 不存在
        this.aiCheckFileList.push(params)
        this.attachmentUploadTableData.push(viewParams);
        this.orderSkuIdArr.push(this.orderSkuId);
      } else {
        this.aiCheckFileList[isExistIndex] = params;
        this.attachmentUploadTableData[isExistIndex] = viewParams;
      }

      console.log(this.aiCheckFileList, 'this.aiCheckFileList')
    },
    showList(listName, val) {
      let content = '';
      // 订单类型 purchaseRequestType 单独处理
      if (listName === 'purchaseRequestType') {
        const valArr = [1, 2];// 其他为空
        if (valArr.includes(Number(val))) {
          content = detailContent[listName][Number(val)]
        }
      } else {
        content = detailContent[listName][Number(val)]
      }
      return content;
    },
    handleTab(row) {
      this.activeIndex = row.index;
      if (this.activeIndex === '0') {
        this.tableLabel = detailContent.yclTableLabel;
      } else if (this.activeIndex === '1') {
        this.tableLabel = detailContent.kcTableLabel;
      }
      this.getData();
    },
    toStockOrder(flag, row) {
      if (flag === 1) {
        const {orderId} = row;
        window.open(
          `${epecMallUrl}/materialPurchasingOrder?orderId=${orderId}&orderFlag=orderDetail&flag=canHandle`,
          '_blank'
        );
      } else if (flag === 2) {
        const { id } = row;
      this.$router.push({
        name: 'StockDetail',
        params: {
          id,
        },
      });
        // const {id, purchaseCompanyId} = row;
        // window.open(
        //   `${epecMallUrl}/materialPurchasingOrder/rawMaterialOrder?id=${id}&purchaseCompanyId=${purchaseCompanyId}&flag=canHandle`,
        //   '_blank'
        // );
      }
    },
    handleClick(val) {
      this.queryData.pageNum = 1;
      this.activeIndex = val.index;
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
    },
    handleFilter(val) {
      this.queryData.pageNum = 1;
    },
    async queryBindOrder(methodName, params) {
      const res = await api[methodName](params);
      if (res.code === '200') {
        this.tableData = res.data || [];
      }
    },
    async queryBindStock(methodName, params) {
      const res = await api[methodName](params);
      if (res.code === '200') {
        this.tableData = res.data || [];
      }
    },
    async queryBindAvailable(methodName, params) {
      const res = await api[methodName](params);
      if (res.code === '200') {
        if (res.data && res.data.length > 0) {
          this.availableData = res.data[0] || {};
          console.log(this.availableData, 'this.availableData')
        }
      }
    },
    getData() {
      const {type = 0, petroMallOrderId} = this.$route.query;
      console.log(typeof type, 'ggg');
      if (type === '2') {
        // 石化商城订单
        const params = {
          petroMallOrderId,
        };
        if (this.activeIndex === '0') {
          this.queryBindOrder('pmQueryBindOrder', params);
        } else if (this.activeIndex === '1') {
          this.queryBindStock('pmQueryBindStock', params);
        } else {
          this.queryBindAvailable('pmQueryBindAvailable', {
            id: petroMallOrderId,
          });
        }
      } else {
        const params = {stockAffirmId: this.stockAffirmId};
        if (this.activeIndex === '0') {
          this.queryBindOrder('queryBindOrder', params);
        } else if (this.activeIndex === '1') {
          this.queryBindStock('queryBindStock', params);
        } else {
          this.queryBindAvailable('queryBindAvailable', params);
        }
      }
    },

    async queryDetail(methodName, params) {
      const res = await api[methodName](params);
      if (res.code === '200') {
        this.formData = res.data || {};
      }
    },

  },
};
</script>

<style scoped lang="scss">
.color-red {
  color: #f0250f;
}

.color-b {
  color: #2d8cf0;
  cursor: pointer;
}
</style>
